const createComponentStateStore = (set) => ({
  modalOpen: false,
  setModalOpen: (value) => set(() => ({ modalOpen: value })),
  rightDrawerOpen: false,
  leftDrawerOpen: false,
  toggleRightDrawer: () =>
    set((state) => ({ rightDrawerOpen: !state.rightDrawerOpen })),
  toggleLeftDrawer: () =>
    set((state) => ({ leftDrawerOpen: !state.leftDrawerOpen })),
  isOpenUniCars: false,
  toggleOpenUniCars: () =>
    set((state) => {
      console.log('state', state.isOpenUniCars);
      return { isOpenUniCars: !state.isOpenUniCars };
    }),
});

export default createComponentStateStore;
